module.exports = __webpack_public_path__ + "img/matic.97e1612f.svg";